<template>
  <v-dialog max-width="400" persistent v-on="$listeners" v-bind="$attrs">
    <v-card class="rounded-lg">
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-subtitle class="mt-3 text-justify">
        {{ subtitle }}
      </v-card-subtitle>
      <v-card-text class="font-weight-black">{{ message }}</v-card-text>
      <v-card-text>
        <v-row justify="center">
          <v-col cols="6" v-for="(image, index) in images" :key="index">
            <v-img :src="image.src" max-height="180" cover class="rounded-lg" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="dark" class="rounded-lg" text @click="cancel">
          {{ $t("events.cancel") }}
        </v-btn>
        <v-btn
          class="rounded-lg"
          color="button"
          @click="confirm"
          :loading="loading"
        >
          {{ $t("events.combos.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: String,
    subtitle: String,
    message: String,
    loading: Boolean,
    images: Array,
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>
